// removed by extract-text-webpack-plugin
module.exports = {"root":"_2z9B5","logo":"_3o6l_","icon":"_x2Y6i"};


//////////////////
// WEBPACK FOOTER
// ./app/components/PageListHeader/PageListHeader.scss
// module id = 878
// module chunks = 9